import { Http } from "@/util";

export function getQcResult(routeId) {
  return Http.get("/admin/qc/result", { routeId });
}

// 保存质检证据资源
export function saveQcResource(resource) {
  return Http.post("/admin/qc/save/resource", resource);
}

// 对每项任务进行审核
export function checkQcItem(item) {
  return Http.post("/admin/qc/detail/check", item);
}

// 完成质检任务
export function finishQcTask(routeId, result) {
  return Http.get("/admin/qc/finish/task", { routeId, result });
}

export function getDailyQcResult(date) {
  return Http.get("/admin/qc/daily/result", { date });
}

export function getDailyQcSummary(date) {
  return Http.get("/admin/qc/daily/summary", { date });
}

// 更新质检项
export function updateQcItem(item) {
  return Http.post("/admin/qc/detail/update", item);
}

// 获取停车时长
export function getCarStopList(param) {
  return Http.get("/admin/qc/car_stop/list", param);
}

export function getRouteResourceList(routeId) {
  return Http.get("/admin/qc/get/route/resource/list", { routeId });
}

// 批量保存质检证据资源
export function batchSaveQcResource(param) {
  return Http.post("/admin/qc/batch_save/resource", param);
}

// 删除质检证据资源
export function removeQcResource(id) {
  return Http.get("/admin/qc/remove/resource", { id });
}
